module.exports = __webpack_public_path__ + "static/media/C3Pay.82752597.svg";